import React from 'react';
import { usePaymentsAccount } from '../../../Data/Payments';
import TopBar from '../../../Components/TopBar';
import Page from '../../../Components/Containers/Page';
import Form, { Actions, RequiredValidator, TextField} from '../../../Components/Form';

const BankAccount = () => {
    const {account, updateBankAccount} = usePaymentsAccount(true);

    return <>
        <TopBar left="BackBtn" title="Bank account" />
        <Page>
            <Form onSubmit={updateBankAccount} data={account?.bankAccount} waitForData goBackOnSubmit>
                <TextField name="holderName" label="Name on account" validators={[RequiredValidator]} />
                <TextField name="sortCode" label="Sort Code" validators={[RequiredValidator]} />
                <TextField name="accountNumber" label="Account Number" validators={[RequiredValidator]} />

                <Actions submit={{label: 'Save'}} cancel={{label: 'Cancel', back: true}} />
            </Form>
        </Page>
    </>
}

export default BankAccount;
